/* ---------------------------------------------------------------------------
   Košík jako vysouvací šuplík (2026-09-22, přání majitelky: „když něco přidám
   do košíku, hned mě to hodí na košík, ale to já nechci — chci, aby člověk mohl
   stále nakupovat").

   Dřív formulář díla odeslal POST na /cart/add a Shopify přesměrovalo na /cart.
   Teď se odeslání zachytí, položka se přidá přes /cart/add.js a z boku vyjede
   panel s obsahem košíku. Zákazník ho zavře a je tam, kde byl.

   Bez JavaScriptu se nic nerozbije: formulář se odešle normálně a skončí na
   stránce košíku jako dřív, odkaz na košík v hlavičce taky pořád vede na /cart.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var supl = document.getElementById('kosik-supl');
  if (!supl || typeof window.fetch !== 'function') return;

  var telo = supl.querySelector('[data-ks-telo]');
  var prazdny = supl.querySelector('[data-ks-prazdny]');
  var pata = supl.querySelector('[data-ks-pata]');
  var soucetEl = supl.querySelector('[data-ks-soucet]');
  var nadpisEl = supl.querySelector('[data-ks-nadpis]');
  var puvodniNadpis = nadpisEl ? nadpisEl.textContent : '';
  var textPridano = supl.dataset.pridano || '';
  var vratitFokus = null;

  function jazyk() {
    return document.documentElement.lang || 'cs';
  }

  function penize(cents, mena) {
    try {
      return new Intl.NumberFormat(jazyk(), { style: 'currency', currency: mena }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(0) + ' ' + mena;
    }
  }

  function otevri() {
    supl.hidden = false;
    // Dvojí rámec: bez něj prohlížeč přechod přeskočí, protože prvek byl hidden.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { supl.classList.add('is-open'); });
    });
    document.documentElement.classList.add('ks-nescroll');
    var prvni = supl.querySelector('[data-ks-zavrit]');
    if (prvni) prvni.focus();
  }

  function zavri() {
    supl.classList.remove('is-open');
    document.documentElement.classList.remove('ks-nescroll');
    window.setTimeout(function () { supl.hidden = true; }, 260);
    if (nadpisEl) nadpisEl.textContent = puvodniNadpis;
    if (vratitFokus && document.contains(vratitFokus)) vratitFokus.focus();
    vratitFokus = null;
  }

  function pocitadlo(n) {
    var ukazatele = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < ukazatele.length; i++) ukazatele[i].textContent = n;
  }

  function radek(item, mena) {
    var el = document.createElement('div');
    el.className = 'ks-radek';
    var obr = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy">'
      : '';
    // Provedení je u děl dlouhé (materiál · provedení · papír), proto menším písmem.
    var varianta = item.variant_title && item.variant_title !== 'Default Title'
      ? '<i>' + item.variant_title + '</i>' : '';
    el.innerHTML =
      '<a class="ks-obr" href="' + item.url + '" tabindex="-1" aria-hidden="true">' + obr + '</a>' +
      '<div class="ks-text"><a href="' + item.url + '"><b>' + item.product_title + '</b></a>' +
      varianta + '<span>' + item.quantity + ' \u00d7 ' + penize(item.final_price, mena) + '</span></div>' +
      '<button class="ks-pryc" type="button" data-ks-pryc="' + item.key + '" ' +
      'aria-label="' + (supl.dataset.odebrat || 'X') + '">\u00d7</button>';
    return el;
  }

  function vykresli(cart) {
    pocitadlo(cart.item_count);
    if (!telo) return;
    telo.innerHTML = '';
    var mena = cart.currency || 'CZK';
    for (var i = 0; i < cart.items.length; i++) telo.appendChild(radek(cart.items[i], mena));
    var jePrazdny = cart.item_count === 0;
    if (prazdny) prazdny.hidden = !jePrazdny;
    if (pata) pata.hidden = jePrazdny;
    if (soucetEl) soucetEl.textContent = penize(cart.total_price, mena);
  }

  function nacti() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
                 { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(vykresli);
  }

  /* Přidání do košíku ze stránky díla */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var akce = form.getAttribute('action') || '';
    if (akce.indexOf('/cart/add') === -1) return;
    e.preventDefault();

    var tlacitka = form.querySelectorAll('[name="add"]');
    for (var i = 0; i < tlacitka.length; i++) tlacitka[i].disabled = true;
    vratitFokus = document.activeElement;

    fetch(akce, { method: 'POST', body: new FormData(form),
                  headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (v) {
        if (!v.ok) throw new Error((v.d && v.d.description) || 'chyba');
        return nacti();
      })
      .then(function () {
        if (nadpisEl && textPridano) nadpisEl.textContent = textPridano;
        otevri();
      })
      .catch(function () {
        // Když se cokoli pokazí, chovej se jako dřív: odešli formulář naostro.
        form.submit();
      })
      .then(function () {
        for (var j = 0; j < tlacitka.length; j++) tlacitka[j].disabled = false;
      });
  });

  /* Odkaz na košík v hlavičce otevře šuplík místo odchodu na /cart */
  document.addEventListener('click', function (e) {
    var odkaz = e.target.closest ? e.target.closest('.cart-link') : null;
    if (odkaz) {
      e.preventDefault();
      vratitFokus = odkaz;
      nacti().then(otevri);
      return;
    }
    if (e.target.closest && e.target.closest('[data-ks-zavrit]')) { zavri(); return; }
    var pryc = e.target.closest && e.target.closest('[data-ks-pryc]');
    if (pryc) {
      pryc.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: pryc.dataset.ksPryc, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(vykresli)
        .catch(function () { pryc.disabled = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !supl.hidden) zavri();
  });
})();
